import styled from "styled-components";
import { TabContent } from "react-bootstrap";

export const ContentTab = styled(TabContent)`
    margin-top: 15px;
`